import { TextField } from "@material-ui/core";
import React from "react";

export default ({
    onChange,
    value,
    label,
    multiline,
    number,
    style,
    placeholder
}) => {

    return (
        <TextField
            placeholder={placeholder && placeholder}
            multiline = {multiline}
            fullWidth
            style= {style}
            id="filled-number"
            label={label && label}
            type={number && "number"}
            value={value}
            onChange={(e) => onChange( e.target.value )}
            InputLabelProps={{
                shrink: true,
            }}
            variant="outlined"
        />
    );
}